// api/meetings.js
import axios from "axios";
import config from "../../../config";

export const startMeeting = async (user1Id, user2Id, meetingType = "marriage", meetingContext, captureModes) => {
  const response = await axios.post(`${config.baseURL}/api/v1/meetings/start`, {
    user1: String(user1Id),
    user2: String(user2Id),
    meetingType,
    meetingContext,
    captureModes,
    startTime: new Date().toISOString(),
  });
  return response.data;
};

export const endMeeting = async (meetingId, user1Id, user2Id) => {
  const response = await axios.post(`${config.baseURL}/api/v1/meetings/${meetingId}/end`, {
    user1: String(user1Id),
    user2: String(user2Id),
    endTime: new Date().toISOString(),
  });
  return response.data;
};

export const getAllMeetingResultsByUsers = async (user1Id, user2Id) => {
  const response = await axios.get(
    `${config.baseURL}/api/v1/meetings/live-result?user1=${user1Id}&user2=${user2Id}`
  );
  return response.data;
};

export const getDateQuestions = async () => {
  const response = await axios.get(`${config.baseURL}/api/v1/questions/date-30`);
  return response.data;
};

export const logMeetingQuestion = async (meetingId, payload) => {
  const response = await axios.post(`${config.baseURL}/api/v1/meetings/${meetingId}/question`, payload);
  return response.data;
};

export const getMeetingQuestions = async (meetingId) => {
  const response = await axios.get(`${config.baseURL}/api/v1/meetings/${meetingId}/questions`);
  return response.data;
};

/**
 * Relationship trajectory
 * GET /api/v1/meetings/trajectory?user1=17&user2=16&window=7d|30d|90d
 */
export const getMeetingTrajectory = async (user1Id, user2Id, window = "7d", endDay) => {
  const qs = new URLSearchParams({
    user1: String(user1Id),
    user2: String(user2Id),
    window: String(window),
  });

  if (endDay) qs.set("endDay", endDay);

  const response = await axios.get(`${config.baseURL}/api/v1/meetings/trajectory?${qs.toString()}`);
  return response.data;
};
export const createZoomMeeting = async (payload = {}) => {
  const response = await axios.post(`${config.baseURL}/api/v1/zoom/create-meeting`, payload);
  return response.data;
};
export const getToolTips = async () => {
  const response = await axios.get(`${config.baseURL}/api/v1/meetings/tooltips`);
  return response.data;
};
export const getActiveMeeting = async (userId) => {
  const response = await axios.get(`${config.baseURL}/api/v1/meetings/active/${userId}`);
  return response.data;
};

// Add to api/meetings.js
export const sendMeetingAnalytics = async (meetingId, analyticsData) => {
  // const token = localStorage.getItem('token');
  const response = await axios.post(
    `${config.baseURL}/api/v1/meetings/${meetingId}/analytics`,
    analyticsData,
    {
      headers: {
        // 'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
  return response.data;
};